module.exports = __webpack_public_path__ + "static/cset_chinese_talent_program_tracker-3d945f52a7b5d2189ba7834f36202656.pdf";